import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./redux/slices/store";

import Login from "./pages/LoginPage";
import Dashboard from "./pages/Dashboard";
import Header from "./components/Header";
import ProtectedRoute from "./components/ProtectedRoute";

import DashboardContent from "./layout/DashboardContent";
import ItemList from "./pages/ItemList";
import ItemCategory from "./pages/ItemCategory";
import ItemModels from "./pages/ItemModel";
import InwardOptionComponent from "./pages/InwardOptionComponent";
import OutwardOptions from "./pages/OutwardOptions";
import RackComponent from "./pages/RackComponent";
import ItemAssignmentForm from "./pages/ItemAssignmentRack";
import Contributor from "./pages/Contributor";
import GifDisplay from "./view/common/GifDisplay";
import CountryMaster from "./pages/CountryMaster";
import StateMaster from "./pages/StateMaster";
import CityMaster from "./pages/CityMaster";
import CurrencyMaster from "./pages/CurrencyMaster";
import GstSlabs from "./pages/GstSlabs";
import UOMMaster from "./pages/UOMMaster";
import CustomerPart from "./pages/CustomerPart";
import NewSupplierPart from "./pages/SupplierPart";
import BomTypesComponent from "./pages/BomTypesComponent";
import NewGRN from "./pages/NewGRN";
import GrnReport from "./components/Report/GrnReport";
import IncoBarTag from "./view/pdf/incoBarTag";
import ScanInward from "./pages/scanning/inward";
import Outward from "./pages/scanning/outward";
import RMInventory from "./pages/RMinventory";
import CurrentStocks from "./pages/CurrentStocks";
import StockSummary from "./pages/stockSummary";
import UserManagement from "./pages/userRole";
import Roles from "./pages/roles"; import PurchaseOrder from "./pages/purchaseOrder";
import StockExpiry from "./pages/stocks/stockexpire";
import StockAged from "./pages/stocks/AgedStock";
import PriceHistory from "./pages/PriceHistory";
import AuthListener from "./components/AuthListener";
import TodayStocks from "./pages/TodayStocks";
import BomMaster from "./pages/bom";
import PendingPO from "./pages/PendingPo";
const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const showHeader = location.pathname !== "/login";

  return (
    <>
      {showHeader && <Header />}
      <main>{children}</main>
    </>
  );
};

const App: React.FC = () => {
  return (
    <Router basename="/">
      <AuthListener />
      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />

        <Route path="/login" element={<Login />} />

        <Route element={<ProtectedRoute />}>
          <Route
            path="/dashboard"
            element={
              <Layout>
                <Dashboard />
              </Layout>
            }
          >
            <Route index element={<DashboardContent />} />
            <Route path="newItem" element={<ItemList />} />
            <Route path="itemCategory" element={<ItemCategory />} />
            <Route path="itemModel" element={<ItemModels />} />
            {/* <Route path="inwardOption" element={<InwardOptionComponent />} /> */}
            {/* <Route path="outwardOption" element={<OutwardOptions />} /> */}
            <Route path="newRack" element={<RackComponent />} />
            <Route path="itemAssignedRack" element={<ItemAssignmentForm />} />
            <Route path="newContributor" element={<Contributor />} />
            <Route path="deliveryPlace" element={<GifDisplay />} />
            <Route path="customerParts" element={<CustomerPart />} />
            <Route path="supplierParts" element={<NewSupplierPart />} />
            <Route path="countryMaster" element={<CountryMaster />} />
            <Route path="stateMaster" element={<StateMaster />} />
            <Route path="cityMaster" element={<CityMaster />} />
            <Route path="currencyMaster" element={<CurrencyMaster />} />
            <Route path="gstSlabMaster" element={<GstSlabs />} />
            <Route path="uomMaster" element={<UOMMaster />} />
            <Route path="bomtypes" element={<BomTypesComponent />} />
            <Route path="approvalRole" element={<GifDisplay />} />
            <Route path="newGRN" element={<NewGRN />} />
            <Route path="grnReport" element={<GrnReport />} />
            <Route path="incobar" element={<IncoBarTag />} />
            <Route path="grnSummary" element={<GifDisplay />} />
            <Route path="grnReport" element={<GifDisplay />} />
            <Route path="ScanInward" element={<ScanInward />} />
            <Route path="Outward" element={<Outward />} />
            <Route path="Inward" element={<ScanInward />} />
            <Route path="Outward" element={<GifDisplay />} />
            <Route path="CurrentStock" element={<CurrentStocks />} />
            <Route path="stocksummary" element={<StockSummary />} />
            <Route path="users" element={<UserManagement />} />
            <Route path="roles" element={<Roles />} />
            <Route path="purchaseorder" element={<PurchaseOrder />} />
            <Route path="stockexpire" element={<StockExpiry />} />
            <Route path="StockAged" element={<StockAged />} />
            <Route path="pricehistory" element={<PriceHistory />} />
            <Route path="todaystocks" element={<TodayStocks />} />
            <Route path="RMinventory" element={<RMInventory />} />
            <Route path="bom" element={<BomMaster />} />
            <Route path="pendingpo" element={<PendingPO />} />

          </Route>
        </Route>

        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </Router>
  );
};

export default App;
